<ng-container [formGroup]="parentFormGroup">
  <div class="form-field-container">
    <mat-form-field
      appearance="outline"
      [floatLabel]="'always'"
      [class.mat-mdc-form-field-invalid]="
        parentFormGroup?.get(currentConfig.property)?.invalid &&
        (parentFormGroup?.get(currentConfig.property)?.touched ||
          parentFormGroup?.get(currentConfig.property)?.dirty)
      "
    >
      <mat-label>{{ currentConfig.displayText }}</mat-label>
      <input
        matInput
        [formControlName]="currentConfig.property"
        class="validation-radio-input"
        [required]="currentConfig?.validators?.required"
      />
      <mat-radio-group
        class="d-flex align-items-flex-start"
        [ngClass]="{ 'ui-disabled': readOnly }"
        [value]="parentFormGroup?.get(currentConfig.property)?.value"
        (change)="onRadioSelectionChange($event.value)"
      >
        @if (!currentConfig?.avoidNone) {
          <mat-radio-button class="mx-2" [value]="null">None</mat-radio-button>
        }
        @for (value of currentConfig.values; track value) {
          <mat-radio-button class="mx-2" [value]="value">
            {{ value }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (parentFormGroup?.get(currentConfig.property)?.errors) {
        <mat-error>
          {{
            currentConfig?.errorMessages?.[
              keys(parentFormGroup?.get(currentConfig.property)?.errors)?.[0]
            ] || "Please review the field"
          }}
        </mat-error>
      }
    </mat-form-field>
  </div>
</ng-container>
